export default __webpack_public_path__ + "static/media/dot-icon.5fbc657d.svg";